import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { IVaccinationDetailed } from '../../../../../../interfaces/Vaccination/IVaccinationDetailed';
import { ITravelHistoryDetailed } from '../../../../../../interfaces/TravelHistory/ITravelHistoryDetailed';
import { TravelHistoryService } from '../../../../../../services/travelHistory.service';
import { TravelHistoryAddEditComponent } from './travel-history-add-edit/travel-history-add-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'src/styles/colors';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-travel-history',
    templateUrl: './travel-history.component.html',
    styleUrls: ['./travel-history.component.css'],
    standalone: false
})
export class TravelHistoryComponent {
  public addComp = TravelHistoryAddEditComponent;

  private destroy$ = new Subject<void>();

  travelHistory?: ITravelHistoryDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly travelHistoryService: TravelHistoryService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  ngOnInit() {
    this.travelHistoryService.travelHistoryLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.travelHistoryService.travelHistoryDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IVaccinationDetailed[]) => {
        this.travelHistory = data;
      });

    this.travelHistoryService.getData();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: ITravelHistoryDetailed) {
    this.travelHistoryService.travelHistoryModalSub.next(true);
    this.travelHistoryService.travelHistoryEditSub.next(item);
  }

  deleteFun(travelHistoryId: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder1'
      )} ${this.translate.instant('Travel History')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.travelHistoryService
          .deleteTravelHistory(travelHistoryId.toString())
          .subscribe({
            next: (d) => {
              this.swalToastService.toastSuccess(
                'Travel history deleted successfully'
              );
              this.travelHistoryService.deleteTravelHistoryFromTable(
                travelHistoryId.toString()
              );
            },
            error: (err) => {
              this.swalToastService.toastError(
                'Unable to delete Travel history'
              );
            },
          });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Travel history is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }
}
